(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["number-counter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const counters = document.querySelectorAll('.number-counter-value');
    const updateCounter = (counter) => {
      const target = +counter.getAttribute('data-value');
      counter.innerText = '0';
      const increment = target / 200;

      const countUp = () => {
        const current = +counter.innerText;
        if (current < target) {
          counter.innerText = Math.ceil(current + increment);
          setTimeout(countUp, 5);
        } else {
          counter.innerText = target;
        }
      };

      countUp();
    };
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          updateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    counters.forEach((counter) => {
      observer.observe(counter);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-videos"] && !Shopify.designMode) return;
  try {
    

  (function () {

    function playVisibleVideos() {

      var videos = document.querySelectorAll('.video-grid video');

      var viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight;

      videos.forEach(function (video) {

        var rect = video.getBoundingClientRect();

        var height =
          rect.bottom - rect.top;

        var visible =
          rect.top < viewportHeight * 0.7 &&
          rect.bottom > viewportHeight * 0.3 &&
          height > 0;

        if (visible) {

          video.muted = true;
          video.autoplay = true;
          video.playsInline = true;

          if (video.paused) {
            video.play().catch(function () {});
          }

        } else {

          if (!video.paused) {
            video.pause();
          }

        }

      });

    }

    if (document.readyState === 'loading') {

      document.addEventListener(
        'DOMContentLoaded',
        playVisibleVideos
      );

    } else {

      playVisibleVideos();

    }

    var scrollTimer;

    window.addEventListener(
      'scroll',
      function () {

        clearTimeout(scrollTimer);

        scrollTimer = setTimeout(
          playVisibleVideos,
          100
        );

      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      playVisibleVideos
    );

  })();


  } catch(e) { console.error(e); }
})();
})();
